<div class="card shadow-sm rounded-3">
  <div class="card-body py-2">
    <div class="d-flex justify-content-between align-items-center">
      <h4 class="fw-bold text-dark m-0">
        <i class="las la-tools me-2"></i> {{ 'REPAIRS.MAINTENANCE_REPAIRS' | translate }}
      </h4>
      <button (click)="inProcess()" class="btn btn-primary btn-sm py-2">
        <i class="las la-plus me-1"></i> {{ 'REPAIRS.ADD_MAINTENANCE' | translate }}
      </button>
    </div>
    <p class="text-muted mb-0">{{ 'REPAIRS.REPAIR_DESCRIPTION' | translate }}</p>
    <hr>
  </div>
  <div class="text-center" style="margin-top: 4rem; margin-bottom: 4rem;">
    <h4>
      <i class="la la-exclamation-triangle me-2"></i>
      <span>{{ 'PROPERTY.NO_REPAIRS' | translate }}</span>
    </h4>
  </div>
</div>

